/*
 * Disables the refund fields of the positions refund.php refuses: those of a wallee order that
 * total 0. Their ids come with the order items box. WooCommerce renders the box anew whenever it
 * reloads the items, so the fields are disabled each time the refund form opens.
 */
export class cAdminOrderRefund {
  // In the capture phase: the handler of WooCommerce ends with return false, which stops the click
  // from bubbling up to the document.
  constructor() {
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element) || event.target.closest('button.refund-items') === null) return;
      this.lockItems();
    }, true);
  }

  lockItems(): void {
    const marker = document.querySelector('#woocommerce-order-items .c-refund-locked') as HTMLElement | null;
    if (marker === null) return;

    for (const id of (marker.dataset.itemIds ?? '').split(',')) {
      const inputs = document.querySelectorAll(`#woocommerce-order-items tr[data-order_item_id="${id}"] .refund input`);
      inputs.forEach(input => {
        (input as HTMLInputElement).disabled = true;
        (input as HTMLInputElement).title    = 'Nicht eingezogen, keine Rückerstattung möglich';
      });
    }
  }
}
